import { toLunar, toSolar, LunarTable, SolarTable, LunarData, SolarData, LunarDate, SolarDate } from "./kor-lunar";

const korLunar = { toLunar, toSolar, LunarTable, SolarTable, LunarData, SolarData };
export default korLunar;
export { toLunar, toSolar, LunarTable, SolarTable, LunarData, SolarData, LunarDate, SolarDate };
